<template>
  <div class="sponsorship" :style="{display:value.sponserItem.length<3?'inline-block':'block','vertical-align':'top'}">
    <b
      class="sponsorship-small-head"
      :style="'color:' + landingPage.textColor"
      >{{ value.title }}</b
    >
    <div
      class="small-green-line"
      :style="'background:' + landingPage.themeColor"
    ></div>
    <div class="logos-wrap">
      <div
        v-for="(sponser, i) in value.sponserItem"
        :key="i"
        class="align"
        :style="{'margin-bottom':sponser.item.logo.imageURL?'30px':'5px'}"
        :class="'logo-' + logosize"
      >
        <div
          :class="{ 'logo-box': !sponser.item.logo.imageURL }"
          :style="'border-color:' + landingPage.themeColor"
        >
          <img
            v-if="sponser.item.logo.imageURL"
            :src="sponser.item.logo.imageURL"
            :alt="sponser.item.text"
          />
          <div v-if="!sponser.item.logo.imageURL">
            {{ sponser.item.text }}
            <div
              class="logo-box-after"
              :style="'border-color:' + landingPage.themeColor"
            ></div>
          </div>
        </div>

        <p v-if="sponser.item.logo.imageURL" class="under-name">
          {{ sponser.item.smallText }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sponsers-Text",
  props: {
    value: Object,
    landingPage: Object,
  },
  data() {
    return {
      bio: false,
    };
  },
  computed: {
    logosize() {
      if (this.value.logoSize) {
        return this.value.logoSize.value.toLowerCase();
      } else {
        return "mid";
      }
    },
  },
};
</script>

<style scoped>
.logo-box-after {
  content: "";
  display: block;
  width: 30px;
  border-top: 3px solid black;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}

.logo-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 10px;
  padding: 10px;
  font-family: Merriweather, serif;
  font-weight: 200;
  font-size: large;
  border-radius: 5px;
  min-width: 200px;
  min-height: 100px;
  color: #717171;
}
.align {
  vertical-align: middle;
  margin-left: 20px;
  margin-right: 20px;
}
p {
  margin-bottom: 0px;
}
.logo-big .logo-box {
  font-size: x-large;
  margin-top: -5px;
}
</style>